<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gvuVJX/tc-custom/9781942266389.jpg?1737164465549" alt="This image is the cover for the book Trail of Ted Bundy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Trail of Ted Bundy
      </h1>
      <p class="bookDescription body article font2">
        <b>The untold true crime story behind the notorious serial killer who preyed on women across the United States from the author of <i>The Bundy Murders</i>.</b><br/>  <br/> Journey back in time to when Ted Bundy was killing young women and girls in the Pacific Northwest and beyond. Within these pages, you’ll find revealing stories from Bundy’s friends as well as his friends of his victims—some being published for the very first time. Discover what it was like to know him while he was actively involved in murder. Learn information and anecdotes about the victims that were not previously shared with the investigators. You’ll also hear from the two former detectives who worked with the author on his book, <i>The Bundy</i><i>Murders</i>, as they dispel commonly held myths about Bundy and offer insight into his deadly career and its impact on those who came into contact with him.<br/>  <br/><i>The Trial</i><i>of Ted Bundy</i> is the story of those who hunted Bundy, those who guarded him, and those who were otherwise part of this strange case in one way or another.<br/>  <br/><b>“Bundy expert Kevin Sullivan has done the painstaking work of filling [in the holes in Bundy’s story] and offering credible notions for those for which information might always be elusive. An important addition to true crime studies.”—Katherine Ramsland, bestselling author of <i>Confession of a Serial Killer: The Untold Story of Dennis Rader, the BTK Killer</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kevin Sullivan
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WildBlue Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?395564a6